import * as React from 'react';
import ErrorBoundary from '../../AdvancedComponents/ErrorBoundary';

export default (props: { children?: React.ReactNode }) => (
    <ErrorBoundary>
        <div className="wrapper">

            <div className="d-flex w-100 signin height100Vh">
                <div className="mainExternal" >
                    <div >

                        {props.children}
                    </div>
                </div>
            </div>
        </div>
    </ErrorBoundary>
);
